module.exports = __webpack_public_path__ + "media/theme/out of stock-7124aae7.svg";